import { services } from '@broadleaf/admin-components';

import { DownloadExport } from '@broadleaf/admin-components/dist/view/named-components/view-types/ExportMaintenance/actions';
import { SetDealerLocationRowAction } from 'app/dealer/components';
import { CustomerAssociationRowAction } from 'app/fleet/components';

import 'app/form/formActionRegistration';
import orderViewActions from 'app/oms/components/AuroraOrderView/action-components';
import fulfillmentCardActions from 'app/oms/components/ItemsOrderViewSection/components/FulfillmentCard/action-components';
import paypalActionComponents from 'app/paypal/components/PayPalView/action-components';
import customImpersonateActions from 'app/view/components/actions';
import customReturnAuthActions from 'app/oms/components/ReturnsOrderViewSection/action-components';
import { EFlyerAction } from 'app/content/components/EFlyer';

const { ActionRegistrar } = services;

ActionRegistrar.registerActionComponent('View', 'ENTITY_GRID', {
  placement: 'ROW',
  type: 'SET_DEALER_LOCATION',
  component: SetDealerLocationRowAction
});
ActionRegistrar.registerActionComponent('External', 'EXTERNAL_GRID', {
  placement: 'ROW',
  type: 'FLEET_CUSTOMER_ASSOCIATION',
  component: CustomerAssociationRowAction
});
ActionRegistrar.registerActionComponent('External', 'EXTERNAL_GRID', {
  placement: 'ROW',
  type: 'DOWNLOAD_EXPORT',
  component: DownloadExport
});
ActionRegistrar.registerActionComponents('View', 'ORDER', orderViewActions);
ActionRegistrar.registerActionComponents(
  'View',
  'ORDER_ITEMS',
  fulfillmentCardActions
);
ActionRegistrar.registerActionComponents(
  'View',
  'PAYPAL',
  paypalActionComponents
);
ActionRegistrar.registerActionComponents(
  'View',
  'ENTITY_GRID',
  customImpersonateActions
);
ActionRegistrar.registerActionComponents(
  'View',
  'ENTITY',
  customImpersonateActions
);
ActionRegistrar.registerActionComponents(
  'View',
  'ORDER_RETURNS',
  customReturnAuthActions
);
ActionRegistrar.registerActionComponent('View', 'CONTENT_VIEW', {
  placement: 'SECONDARY',
  type: 'EFLYER',
  component: EFlyerAction
});
